module.exports = __webpack_public_path__ + "images/mobile/tower-logo-yellow-173240cd4120ddfa79f2edbf17e4b909.svg";